module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Among the Fair Magnolias: Four Southern Love Stories")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "Aok"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pz11-2"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-1.jpg",
      "src": "images/img-7-1.jpg"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#toc1",
      "id": "con1"
    }
  }, [_vm._v("A NOTE FROM THE AUTHOR")]), _c('img', {
    staticStyle: {
      "vertical-align": "middle"
    },
    attrs: {
      "alt": "images/img-7-2.jpg",
      "src": "images/img-7-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "pz11-6"
    }
  }, [_vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EAR")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADERS, ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-7"
    }
  }, [_vm._v(" Since childhood, the beach is the place where I have felt most alive and closest to God. There is something about the power and beauty of the ocean, the golden light of a sunrise over water that calms my heart and fuels my creativity. Many of my books were first conceived during an early-morning beach walk. When I was offered the chance to write a novella for this collection, I knew right away it would be set on Pawleys Island, South Carolina, one of my favorite places on earth. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz11-8"
    }
  }, [_vm._v(" If you have read my novel "), _c('i', [_vm._v("Carolina Gold")]), _vm._v(", this setting will be familiar to you. My fictional character Charlotte Fraser grew up spending her summers in her family’s cottage on Pawleys. For "), _c('i', [_vm._v("A Heart So True")]), _vm._v(" I couldn’t resist returning to a place I love to give you another glimpse of Charlotte at age fifteen, before she became mistress of Fairhaven, her father’s rice plantation on the Waccamaw River. And I’ve included a scene in which you will catch up with Celia Browning of "), _c('i', [_vm._v("The Bracelet")]), _vm._v(", a year after her marriage to her childhood sweetheart, Sutton Mackay. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "pz12-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v(" Now I hope you will enjoy meeting a new heroine, Abby Clayton. In "), _c('i', [_vm._v("A Heart So True")]), _vm._v(", a beach barbecue sets the stage for events that compel Abby to make hard choices that change the course of her future. ")])]), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_c('p', {
    staticClass: "txr1",
    attrs: {
      "id": "pz12-2"
    }
  }, [_vm._v(" Be blessed, ")]), _vm._v(" "), _c('p', {
    staticClass: "txr1",
    attrs: {
      "id": "pz12-3"
    }
  }, [_vm._v(" Dorothy ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baaaf0e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter01.vue
// module id = 69
// module chunks = 0